import { get, post } from "./api";
import { ProblemDetails } from "../models/Http";
import {
  CreateEmailTemplate,
  EmailTemplate,
  SelectableValues,
  SendEmailPreview,
  SendEmailToTargetGroup,
  SendPushNotificationToTargetGroup
} from "../models/Marketing";
import { err, ok, Result, Unit } from "../result";

export const getSelectableValues = async (): Promise<
  Result<ProblemDetails, SelectableValues>
> => {
  const response = await get("/v1/marketing/selectable-values");
  const content = await response.json();

  if (response.ok) {
    return ok(content as SelectableValues);
  }

  return err(content as ProblemDetails);
};

export const getEmailTemplates = async (
  updatedSinceDaysBack?: number
): Promise<Result<ProblemDetails, ReadonlyArray<EmailTemplate>>> => {
  const response = await get("/v1/marketing/email-templates", {
    updatedSinceDaysBack
  });
  const content = await response.json();

  if (response.ok) {
    return ok(content as ReadonlyArray<EmailTemplate>);
  }

  return err(content as ProblemDetails);
};

export const createEmailTemplate = async (
  model: CreateEmailTemplate
): Promise<Result<ProblemDetails, EmailTemplate>> => {
  const response = await post("/v1/marketing/email-templates", model);
  const content = await response.json();

  if (response.ok) {
    return ok(content as EmailTemplate);
  }

  return err(content as ProblemDetails);
};

export const sendEmailPreview = async (
  model: SendEmailPreview
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await post("/v1/marketing/email-preview/send", model);

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();

  return err(content as ProblemDetails);
};

export const sendEmailToTargetGroup = async (
  model: SendEmailToTargetGroup
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await post("/v1/marketing/email/send", model);

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();

  return err(content as ProblemDetails);
};

export const sendPushNotificationToTargetGroup = async (
  model: SendPushNotificationToTargetGroup
): Promise<Result<ProblemDetails, Unit>> => {
  const response = await post("/v1/marketing/push/send", model);

  if (response.ok) {
    return ok({});
  }

  const content = await response.json();

  return err(content as ProblemDetails);
};
